module.exports = __webpack_public_path__ + "static/paquete-5-da645321f52a4bbbe42670fc613355b4.svg";